import sortData from '@shared/lib/general/sortData';
import initialState from './customerInitialState';

const mutations = {
  CUSTOMER_CHANGE_PROFILE_TAB: (state, payload) => {
    const {
      activeTab,
    } = payload;

    const {
      profileIncompleted,
      profileCompleted,
      baseProfile,
      filters,
    } = state;

    let freeItems = [];
    let priorityItems = [];
    let preventItems = [];
    let standardItems = [];
    let partnerItems = [];
    let pilotItems = [];

    if (activeTab === 'complete') {
      state.tableData = profileCompleted;
    } else if (activeTab === 'incomplete') {
      state.tableData = profileIncompleted;
    } else if (activeTab === 'base') {
      state.tableData = baseProfile;
    }

    if (
      filters.free
      || filters.priority
      || filters.prevent
      || filters.standard
      || filters.partner
      || filters.pilot
    ) {
      if (filters.free) {
        freeItems = state.tableData.filter(
          (item) => item.customer.membershipPlan.tier === 'Free',
        );
      }
      if (filters.priority) {
        priorityItems = state.tableData.filter(
          (item) => item.customer.membershipPlan.tier === 'Priority',
        );
      }
      if (filters.prevent) {
        preventItems = state.tableData.filter(
          (item) => item.customer.membershipPlan.tier === 'Prevent',
        );
      }
      if (filters.standard) {
        standardItems = state.tableData.filter(
          (item) => item.customer.membershipPlan.tier === 'Standard',
        );
      }
      if (filters.partner) {
        partnerItems = state.tableData.filter(
          (item) => item.customer.membershipPlan.tier === 'Partner',
        );
      }
      if (filters.pilot) {
        pilotItems = state.tableData.filter(
          (item) => item.customer.membershipPlan.tier === 'Pilot',
        );
      }

      const newTableData = [
        ...freeItems,
        ...priorityItems,
        ...preventItems,
        ...standardItems,
        ...partnerItems,
        ...pilotItems,
      ];
      state.tableData = newTableData;
    }

    state.activeProfileTab = activeTab;
  },
  CUSTOMER_CHANGE_VALUE: (state, payload) => {
    const {
      field,
      value,
    } = payload;

    state[field] = value;
  },
  CUSTOMER_CHANGE_VALUES: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      state[field] = value;
    });
  },
  CUSTOMER_SET_SORT: (state, payload) => {
    const {
      field,
      sort,
    } = payload;

    Object.keys(state.sort).forEach((s) => {
      if (s === field) {
        state.sort[s] = sort;
      } else {
        state.sort[s] = false;
      }
    });

    const filterActive = Object.keys(state.filter).reduce((acc, f) => {
      let active = acc;
      if (f === 'corporation' && state.filter[f] !== 'all') {
        active = true;
      } else if (state.filter[f] && f !== 'corporation') {
        active = true;
      }
      return active;
    }, false);

    let newTableData;

    if (filterActive) {
      newTableData = state.tableData.slice();
    } else {
      newTableData = state.allCustomers.slice();
    }

    if (sort) {
      newTableData = sortData(newTableData, field, sort);
    }

    state.tableData = newTableData;
  },
  CUSTOMER_SET_CUSTOMERS: (state, payload) => {
    const {
      allCustomers,
      profileIncompleted,
      profileCompleted,
      baseProfile,
    } = payload;

    const {
      activeProfileTab,
    } = state;

    if (activeProfileTab === 'complete') {
      state.tableData = profileCompleted;
    } else if (activeProfileTab === 'incomplete') {
      state.tableData = profileIncompleted;
    } else if (activeProfileTab === 'base') {
      state.tableData = baseProfile;
    }
    if (activeProfileTab === 'invited') {
      state.allProspects = Object.freeze(allCustomers);
    } else {
      state.allCustomers = Object.freeze(allCustomers);
    }
    state.profileCompleted = profileCompleted;
    state.baseProfile = baseProfile;
    state.profileIncompleted = profileIncompleted;

    state.loading = false;
  },
  CUSTOMER_CHANGE_TABLE_OPTION: (state, payload) => {
    const {
      field,
      value,
    } = payload;
    const newCustomerTableOptions = {
      ...state.customerTableOptions,
      [field]: value,
    };
    state.customerTableOptions = newCustomerTableOptions;
  },
  CUSTOMER_CHANGE_TABLE_SORT: (state, payload) => {
    const {
      sortBy,
      sortDesc,
    } = payload;
    state.customerTableOptions = {
      ...state.customerTableOptions,
      sortBy,
      sortDesc,
    };
  },
  ADMIN_LOGOUT: (state) => {
    Object.assign(state, initialState());
  },
};

export default mutations;
